import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { ActivePageService } from '@services/active-page/active-page.service';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { ToastService } from '@services/common/toast.service';
import { QuestionnaireConfigState } from '@state/questionnaire.config.state';
import { QuestionnaireState } from '@state/questionnaire.state';
import { PageDto } from 'app/@types/dto/page-dto.model';
import { QuestionInstanceDto } from 'app/@types/dto/question-instance-dto.model';
import { QuestionnaireConfig } from 'app/@types/dto/questionnaire-config.model';
import { QuestionnaireDto } from 'app/@types/dto/questionnaire-dto.model';
import { combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { OrganizationState } from '@state/organization.state';
import { OrganizationEntityDto } from 'app/@types/dto/organization-entity-dto.model';
import { OrganizationDto } from 'app/@types/dto/organization-dto.model';

@Component({
    selector: 'app-mobility-page',
    templateUrl: './mobility-page.component.html',
    styleUrls: ['./mobility-page.component.scss'],
    standalone: false,
})
export class MobilityPageComponent implements OnInit, OnDestroy {
    @Select(QuestionnaireConfigState.getStaticConfig) config$!: Observable<QuestionnaireConfig>;
    @Select(QuestionnaireState.getQuestionInstances) questionInstancePerQuestionId$!: Observable<
        Map<string, QuestionInstanceDto[]>
    >;
    @Select(QuestionnaireState.getExternalUpdate) externalUpdates$!: Observable<Set<string>>;
    @Select(QuestionnaireState.getQuestionnaire) questionnaire$!: Observable<QuestionnaireDto>;
    @Select(OrganizationState.getEntities) entities$!: Observable<OrganizationEntityDto[]>;
    @Select(OrganizationState.getOrganization) organization$!: Observable<OrganizationDto>;

    private ngUnsubscribe = new Subject<void>();
    // @ts-expect-error: TODO: Remove ignore when types are fixed
    public activePage: PageDto;
    // @ts-expect-error: TODO: Remove ignore when types are fixed
    public config: QuestionnaireConfig;
    private questionInstancePerQuestionCode: Map<string, QuestionInstanceDto[]> = new Map<
        string,
        QuestionInstanceDto[]
    >();
    public externalUpdates: Set<string> = new Set();
    public currentEntityFte: number = 0;
    public isLoaded: boolean = false;
    // @ts-expect-error: TODO: Remove ignore when types are fixed
    public questionnaire: QuestionnaireDto;
    public activeSubSection: string = '';
    public organizationId: string = '';
    public questionnaireId: string = '';
    public locale: string = '';
    public isInit: boolean = false;

    //Constructor
    constructor(
        private activePageService: ActivePageService,
        public translateService: CustomTranslateService,
        private store: Store,
        private toastService: ToastService,
        private cdr: ChangeDetectorRef,
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.activePageService.getActivePage(),
            this.config$,
            this.questionInstancePerQuestionId$,
            this.questionnaire$,
            this.entities$,
            this.organization$,
        ])
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(([page, config, questionInstancePerQuestionCode, questionnaire, entities, organization]) => {
                if (
                    page &&
                    config &&
                    questionInstancePerQuestionCode &&
                    questionnaire &&
                    questionnaire.id &&
                    organization &&
                    organization.uid
                ) {
                    this.activePage = page;
                    this.config = config;
                    this.questionInstancePerQuestionCode = questionInstancePerQuestionCode;
                    this.questionnaire = questionnaire;
                    this.currentEntityFte =
                        entities.find((e) => e.id === this.questionnaire.organizationEntityId)?.employeesCount ?? 0;
                    this.organizationId = organization.uid;
                    this.questionnaireId = questionnaire.id;
                    this.locale = this.translateService.currentLang;
                    this.isInit = true;
                }
            });
        this.translateService.onLangChange.pipe(takeUntil(this.ngUnsubscribe)).subscribe((_langChangeEvent) => {
            this.locale = this.translateService.currentLang;
        });
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next();
    }
}
